module.exports = __webpack_public_path__ + "55fd169c0fd0a2efb7cf5f0ea032becf.svg";